import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ic-drop-down-white.svg'
import _imports_1 from '@/assets/images/ic-close-modal.svg'


const _withScopeId = n => (_pushScopeId("data-v-465be51e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-stat map-stat--shrinked" }
const _hoisted_2 = { class: "map-stat__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Налогоплательщики и объекты", -1))
const _hoisted_4 = { class: "map-stat__item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Налогоплательщики", -1))
const _hoisted_6 = { class: "map-stat__item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Объекты", -1))
const _hoisted_8 = { class: "map-stat__item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "ККМ", -1))
const _hoisted_10 = { class: "map-stat map-stat--center map-stat--shrinked" }
const _hoisted_11 = { class: "map-stat__inner" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Статусы объектов", -1))
const _hoisted_13 = { class: "map-stat__item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "map-stat__item-point map-stat__item-point--6" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Обработан", -1))
const _hoisted_16 = { class: "map-stat__item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "map-stat__item-point map-stat__item-point--3" })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Не обработан", -1))
const _hoisted_19 = { class: "map-stat map-stat--right map-stat--shrinked" }
const _hoisted_20 = { class: "map-stat__inner" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Статусы налогоплательщиков", -1))
const _hoisted_22 = { class: "map-stat__item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "map-stat__item-point map-stat__item-point--6" })
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Обработан", -1))
const _hoisted_25 = { class: "map-stat__item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "map-stat__item-point map-stat__item-point--3" })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "map-stat__item-name" }, "Не обработан", -1))
const _hoisted_28 = { id: "map" }
const _hoisted_29 = { class: "map-controls" }
const _hoisted_30 = { class: "map-layers" }
const _hoisted_31 = { class: "map-stat__checkbox" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Слой объектов торговли", -1))
const _hoisted_33 = { class: "map-stat__checkbox" }
const _hoisted_34 = { class: "map-status" }
const _hoisted_35 = { class: "map-search" }
const _hoisted_36 = {
  key: 0,
  class: "map-card-container"
}
const _hoisted_37 = {
  key: 0,
  class: "type"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Идёт загрузка...", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "tno" }
const _hoisted_41 = { class: "address" }
const _hoisted_42 = { class: "type" }
const _hoisted_43 = { class: "name" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "objects" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "object-title" }, "Налогоплательщики", -1))
const _hoisted_48 = {
  key: 0,
  class: "no-data"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Нет данных", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "name" }
const _hoisted_53 = { class: "inn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerHeader = _resolveComponent("ContainerHeader")!
  const _component_UiCheckbox = _resolveComponent("UiCheckbox")!
  const _component_ColorSelector = _resolveComponent("ColorSelector")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, { style: {"padding-bottom":"0"} }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_ContainerHeader, { class: "map-stats map-stats--shrinked" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("td", null, _toDisplayString(_ctx.isAdmin === true ? _ctx.statistic?.tnoStat?.taxPayer : _ctx.statistic.values?.taxPayer), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("td", null, _toDisplayString(_ctx.isAdmin === true ? _ctx.statistic?.tnoStat?.taxObject : _ctx.statistic.values?.taxObject), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("td", null, _toDisplayString(_ctx.isAdmin === true ? _ctx.statistic?.tnoStat?.kkm : _ctx.statistic.values?.kkm), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, [
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("td", null, _toDisplayString(_ctx.statistic?.statusStat?.processed), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("td", null, _toDisplayString(_ctx.statistic?.statusStat?.notprocessed), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", null, [
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_22, [
                      _hoisted_23,
                      _hoisted_24,
                      _createElementVNode("td", null, _toDisplayString(_ctx.isAdmin === true ? _ctx.statistic?.nalogPayersStat?.processed : _ctx.statistic?.nalogPayer?.processed), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("td", null, _toDisplayString(_ctx.isAdmin === true ? _ctx.statistic?.nalogPayersStat?.notprocessed : _ctx.statistic?.nalogPayer?.notprocessed), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.toggledMenu]
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", {
          class: "header-toggler",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggledMenu = !_ctx.toggledMenu)),
          style: _normalizeStyle({position: _ctx.toggledMenu ? 'fixed': 'absolute'})
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(["header-toggler__toggle-chevron", {'header-toggler__toggle-chevron__toggled': _ctx.toggledMenu}]),
            src: _imports_0
          }, null, 2)
        ], 4),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", null, [
                _createVNode(_component_UiCheckbox, {
                  modelValue: _ctx.layers.marker,
                  onChangeValue: _cache[1] || (_cache[1] = ($event: any) => (_ctx.layers.marker = !_ctx.layers.marker)),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["modelValue"]),
                _hoisted_32
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", null, [
                _createVNode(_component_UiCheckbox, {
                  modelValue: _ctx.layers.kad,
                  onChangeValue: _cache[3] || (_cache[3] = ($event: any) => (_ctx.layers.kad = !_ctx.layers.kad)),
                  disabled: _ctx.layers.kadFetch,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("span", null, "Слой кадастровых границ " + _toDisplayString(_ctx.layers.kadFetch ? '(Загрузка...)' : ''), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_ColorSelector, {
              modelValue: _ctx.selectedStatus,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedStatus) = $event)),
              exclude: "DUPLICATE"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_UiInput, {
              clear: "",
              search: "",
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$store.commit('map/SET_SEARCH', $event))),
              placeholder: "Поиск объектов и адресов",
              onClearSearch: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$store.commit('map/SET_SEARCH', '')))
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.currentAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              (_ctx.objectFetching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: "card-title",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goToObject && _ctx.goToObject(...args)))
                    }, _toDisplayString(_ctx.currentObject?.tradeObject?.address?.yandexAddressFull || _ctx.currentObject?.tradeObject?.address?.userInput), 1),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.currentObject?.tradeObject?.ugnsTno?.ugnsTnoCode), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currentObject?.tradeObject?.address?.yandexAddressFull || _ctx.currentObject?.tradeObject?.address?.userInput), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, _toDisplayString(`${_ctx.currentObject?.tradeObject?.buildingType?.value || ''} ${_ctx.currentObject?.tradeObject?.buildYear || ''}`), 1),
                      _createElementVNode("div", {
                        class: "close",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeObject && _ctx.closeObject(...args)))
                      }, _hoisted_45)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      (!_ctx.currentObject?.nalogPayers.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.currentObject?.nalogPayers, (val) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", {
                                    class: "status",
                                    style: _normalizeStyle(`background: ${_ctx.statusColor(val.objectStatus)}`)
                                  }, null, 4),
                                  _createVNode(_component_router_link, {
                                    class: "object-name",
                                    to: `/registry/tax-payers/${val.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(val?.objectName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("div", _hoisted_53, _toDisplayString(val?.inn), 1)
                              ])
                            ]))
                          }), 256))
                    ])
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}